import { Box, Stack } from '@sixfold/common-ui';
import React from 'react';

import { SignupStatus } from './signup_status';
import { CompanyOnboardingQuery, UnifiedCompanySignupStatusUpdateInput } from '../../../lib/graphql';
import { CompanyInvitationsContainer } from '../../containers/company_invitations_container';

export interface OnboardingViewProps {
  data: CompanyOnboardingQuery;
  updateSignupStatus: (companyId: string, input: UnifiedCompanySignupStatusUpdateInput) => Promise<void>;
}

export const CompanyOnboardingView: React.FC<OnboardingViewProps> = (props) => {
  return (
    <Stack direction="row" gap="medium">
      <Box style={{ flex: 1 }}>
        <Stack className="m8__horizontal" alignItems="center" justifyContent="space-between">
          <div>
            <h2>Onboarding status</h2>
          </div>
        </Stack>
        <SignupStatus {...props} />
      </Box>
      <Box style={{ flex: 1 }}>
        {props.data.company ? (
          <>
            <h2>Received invitations</h2>
            <CompanyInvitationsContainer companyId={props.data.company?.company_id} />
          </>
        ) : null}
      </Box>
    </Stack>
  );
};
